export const READY = 'ready'
export const UNBOUND = 'unbound' // 網紅授權未綁定
export const UNPUBLISHED = 'unpublished'
export const LIVE = 'live'
export const LIVE_STOPPED = 'live_stopped'
export const LIVE_REPLAY = 'live_replay'
